/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";

import { useFormContext } from "react-hook-form";

import { Box, Card, Tabs } from "@origin-digital/ods-core";

import { IIRecommendationResponse } from "@/contract/generated/electrify-v1";

import { solarOutlook as content } from "./content.json";
import { SingleSystem } from "./SingleSystem";
import { useMediaQuery, useTheme } from "@mui/material";
import { StyledTab } from "@/components/StyledTab";

type SolarOutlookWrapperProps = {
  solarOutlook: IIRecommendationResponse;
  medianSizeIndex: number;
};

export const SolarOutlookWrapper = ({
  solarOutlook,
  medianSizeIndex,
}: SolarOutlookWrapperProps) => {
  const { systemData = [] } = solarOutlook;
  const { setValue } = useFormContext();
  const [tabIndex, setTabIndex] = useState(medianSizeIndex);

  const theme = useTheme();
  const isSmDown = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    setTabIndex(medianSizeIndex);
    setValue("selectedSystemSize", systemData[medianSizeIndex]?.size ?? 0);
  }, [systemData, medianSizeIndex]);

  return (
    <Card
      paddingYSpecific="none"
      paddingXSpecific="none"
      data-id={content.testId.wrapper}
    >
      <Box paddingBottom={["xlarge", "xxlarge"]}>
        {systemData.length ? (
          systemData.length > 1 ? (
            <Tabs
              value={tabIndex}
              size="small"
              variant="fullWidth"
              data-id={content.testId.tabs}
            >
              {systemData.map((recommendationSystem, idx) => (
                <StyledTab
                  key={recommendationSystem.size}
                  muiProps={{
                    onClick: () => {
                      setTabIndex(idx);
                      setValue("selectedSystemSize", recommendationSystem.size);
                    },
                  }}
                  className={isSmDown ? "mobile-tab" : ""}
                  label={`${recommendationSystem.size}kW`}
                >
                  <SingleSystem
                    solarOutlook={solarOutlook}
                    recommendationSystem={recommendationSystem}
                  />
                </StyledTab>
              ))}
            </Tabs>
          ) : (
            <SingleSystem
              solarOutlook={solarOutlook}
              recommendationSystem={systemData[0]}
              showAlert
            />
          )
        ) : (
          <></>
        )}
      </Box>
    </Card>
  );
};
